import { registerSoundImplementation } from '~/api/player'

if (typeof window !== 'undefined') {
  window.funkwhale = {
    registerSoundImplementation
  }
}
